import PropTypes from 'prop-types';
import React from 'react';
import { connect as connectR } from 'react-redux';
import { Button } from 'react-bootstrap';
import ValidatorFormGroup from '../../main/validator-form-group';
import Postit from '../../main/postit';
import translate from '../../translate';
import { OrderByMail } from '../../../store/orderSlice';
import {
    REQUEST_FAILURE,
    REQUEST_INITIAL,
    REQUEST_PENDING,
    REQUEST_SUCCESS,
} from '../../../store/network/managedRequest';
import { PbRequest } from '../../../store/pbRequest';

const VALIDATORS = {
    message: { isValid: (value) => /[^\s]{3}/.test(value) },
};

const POSSIBLE_STATUSES = [
    REQUEST_INITIAL,
    REQUEST_PENDING,
    REQUEST_SUCCESS,
    REQUEST_FAILURE,
];

class OrderPostit extends React.Component {
    static propTypes = {
        strings: PropTypes.object,
        OrderByMail: PropTypes.func.isRequired,
        orderByMailStatus: PropTypes.oneOf(POSSIBLE_STATUSES).isRequired,
    };

    state = {
        message: '',
        _dirty: false,
    };

    _isValid = () => {
        return this.state.message.length;
    };

    _handleFormChange = (key, value) => {
        const dirt = {};
        dirt[key] = true;
        this.setState({
            message: value,
            _dirty: dirt,
            _isValid: VALIDATORS[key].isValid(value),
        });
    };

    submitForm = () => {
        this.props.OrderByMail(this.state.message);
    };

    renderMainContent = () => {
        const messageSuccessful =
            this.props.orderByMailStatus === REQUEST_SUCCESS;
        const messageInProgress =
            this.props.orderByMailStatus === REQUEST_PENDING;

        if (messageSuccessful) {
            return (
                <p className="confirmation-text">
                    {this.props.strings.confirmationText}
                </p>
            );
        } else {
            return (
                <div>
                    <ValidatorFormGroup
                        label={this.props.strings.messageLabel}
                        hideErrorLabel={
                            !this.state._dirty.message ||
                            VALIDATORS.message.isValid(this.state.message)
                        }
                        errorLabel={this.props.strings.message_error}
                    >
                        <textarea
                            value={this.state.message}
                            className="form-control"
                            name="message"
                            rows="6"
                            onChange={(event) => {
                                this._handleFormChange(
                                    'message',
                                    event.target.value
                                );
                            }}
                        />
                    </ValidatorFormGroup>
                    <Button
                        type="button"
                        onClick={this.submitForm}
                        disabled={!this.state._isValid || messageInProgress}
                        className={'btn btn-primary'}
                    >
                        {messageInProgress
                            ? '...'
                            : this.props.strings.buttonLabel}
                    </Button>
                </div>
            );
        }
    };

    render() {
        return (
            <Postit title={this.props.strings.title} className="order-postit">
                <p>{this.props.strings.text}</p>
                {this.renderMainContent()}
            </Postit>
        );
    }
}

export default connectR(
    (state) => ({
        orderByMailStatus:
            state.pbRequest[PbRequest.PLACE_ORDER_BY_MAIL].status,
    }),
    { OrderByMail }
)(translate('OrderPostit')(OrderPostit));
